var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-textarea"},[_c('QuestionRichBody',{attrs:{"options":_vm.options,"value":_vm.element.labels[_vm.lang],"lang":_vm.lang,"label":_vm.L.elTextareaLabel || 'Text'},on:{"input":function($event){return _vm.updateBody($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }